<template>
  <action-message :on="showToast" :error="true" :message="toastMessage" />
  <div class="flex items-center space-x-4">
    <div>
      <div
        class="rounded-full w-12 h-12 flex justify-center items-center relative z-10"
        :class="defaultDeviceIconCssClass()"
      >
        <img :src="deviceIcon" :alt="deviceType" width="20" height="20" class="" />
      </div>
    </div>

    <div class="">
      <Menu as="div" class="relative inline-block text-left">
        <div>
          <MenuButton
            class="
              items-center
              w-16
              h-12
              rounded-full
              text-sm
              font-medium
              text-white
              devices-dropdown
              grid
              justify-items-end
            "
          >
            <ChevronDownIcon class="mr-1 ml-2 h-5 w-5" aria-hidden="true" />
          </MenuButton>
        </div>

        <transition>
          <MenuItems
            class="
              absolute
              left-0
              mt-2
              w-56
              origin-top-right
              rounded-md
              bg-white
              shadow-lg
              ring-1 ring-gray-300
              focus:outline-none
            "
            style="z-index: 100"
          >
            <div class="px-1 py-1">
              <MenuItem v-for="device in devices" :key="device.deviceId">
                <button
                  class="
                    p-2
                    flex
                    group
                    w-full
                    text-sm
                    rounded-md
                    justify-center
                    text-gray-900
                    hover:text-white
                    hover:bg-vice-teal-600
                  "
                  @click="selectDeviceHandler(device)"
                >
                  {{ device.label }}
                </button>
              </MenuItem>
            </div>
          </MenuItems>
        </transition>
      </Menu>
    </div>
    <div class="">
      <div class="device-type-label-regular font-medium">{{ deviceType }}</div>
      <div class="device-label-regular font-medium">
        <span v-if="deviceLabel">{{ deviceLabel }}</span>
        <span v-else>Not Setup</span>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, watch, onMounted } from 'vue';
import { ChevronDownIcon } from '@heroicons/vue/solid';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import useDeviceAndSessionSetupStore from '@/Stores/useDeviceAndSessionSetupStore';
import ActionMessage from '@/Jetstream/ActionMessage.vue';

export default {
  name: 'DefaultDeviceSelector',
  props: {
    deviceIcon: {
      type: String,
      required: true,
    },
    deviceType: {
      type: String,
      required: true,
    },
    deviceKind: {
      type: String,
      required: true,
    },
  },
  components: {
    ChevronDownIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    ActionMessage,
  },
  setup(props) {
    const deviceAndSessionSetupStore = useDeviceAndSessionSetupStore();

    const devices = ref([]);
    const showToast = ref(false);
    const deviceLabel = ref(null);
    const toastMessage = ref('Device adding error');

    onMounted(() => {
      // Set device label to slot if device was saved in this slot
      deviceLabel.value = deviceAndSessionSetupStore.getClinicianConnectedDefaultDevice(
        props.deviceKind,
      )?.label;

      // get devices from storage if page was not reloaded
      // TODO: to understand in more detail
      devices.value = deviceAndSessionSetupStore.getConnectedDevices(props.deviceKind);
    });

    // watching for Pinia storage initialization to get devices list according to
    // device kind
    watch(
      () => deviceAndSessionSetupStore.getConnectedDevices(props.deviceKind),
      (devicesList) => {
        devices.value = devicesList;
      },
    );

    const selectDeviceHandler = (device) => {
      axios
        .post(route('clinician.set-default-device'), {
          device_kind: props.deviceKind,
          device_data: device,
        })
        .then(() => {
          // add to pinia
          deviceAndSessionSetupStore.manageDefaultClinicianDevices(props.deviceKind, device);

          deviceLabel.value = device.label;
        })
        .catch((e) => {
          console.log(e);
          showToast.value = true;
        });
    };

    const defaultDeviceIconCssClass = () =>
      deviceLabel.value ? 'bg-vice-teal-600' : 'bg-gray-200';

    return {
      devices,
      selectDeviceHandler,
      showToast,
      toastMessage,
      deviceLabel,
      defaultDeviceIconCssClass,
    };
  },
};
</script>
<style scoped>
.device-type-label-regular {
  color: #881337;
  font-size: 16px;
}

.device-label-regular {
  font-size: 12px;
  color: #4b4b4b;
}
.devices-dropdown {
  background-color: #0f2630;
  margin-left: -55px;
}
</style>
